function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { T, useTranslate } from 'shared/helper/translate';
var RubriqSearchInput = function RubriqSearchInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(Boolean(value)),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var inputRef = useRef(null);
  useEffect(function () {
    if (expanded && inputRef.current) {
      inputRef.current.focus();
    }
  }, [expanded]);
  var handleClear = function handleClear() {
    _onChange('');
    setExpanded(false);
  };
  if (!expanded) {
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "not-global btn bg-white border rounded-2 px-3 d-flex align-items-center gap-2 text-nowrap rubriq-search-button",
      onClick: function onClick() {
        return setExpanded(true);
      }
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-magnifying-glass"
    }), /*#__PURE__*/React.createElement(T, {
      source: "rubriq.search"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "input-group rubriq-search-input",
    style: {
      maxWidth: '260px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "input-group-text bg-white border-end-0"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-magnifying-glass",
    className: "text-muted"
  })), /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    type: "text",
    className: "form-control border-start-0 border-end-0 ps-0",
    "aria-label": t('rubriq.search-files'),
    placeholder: t('rubriq.search-files'),
    value: value,
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "not-global btn bg-white border border-start-0",
    "aria-label": t('rubriq.clear-search'),
    onClick: handleClear
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-xmark",
    className: "text-muted"
  })));
};
export default RubriqSearchInput;